// Componente per sistema ExeDialog DDT2026 - Step num_silos
import React, { useState, useRef, useEffect } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { ValoriVerificati } from './ValoriVerificati';

export function NumSilos(props) {
    const { currURLSearchParams, onFinish, verificaData } = props;
    const inputRef = useRef();
    
    const [numSilos, setNumSilos] = useState(
        currURLSearchParams.get('num_silos') 
            ? parseInt(currURLSearchParams.get('num_silos'), 10) 
            : null
    );

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.getInput().focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (numSilos !== null && numSilos >= 0) {
            onFinish({ num_silos: numSilos });
        }
    };

    return (
        <div className="card-body">
            <h5 className="card-title">Numero Silos</h5>
            <p className="text-muted">Inserisci il numero di silos.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="num_silos" className="form-label">Numero Silos</label>
                    <InputNumber 
                        ref={inputRef}
                        id="num_silos"
                        value={numSilos}
                        onValueChange={(e) => setNumSilos(e.value)}
                        min={0}
                        className="w-100"
                    />
                </div>

                <button className="btn btn-primary" disabled={numSilos === null || numSilos < 0}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

NumSilos.displayName = 'num_silos';
